<template>
  <DialogLayout
    title="料金マスタ準備"
    :visible.sync="dialogVisible"
    width="45em"
    @open="open"
  >
    <template #form>
      <PreparationForm
        ref="preparationForm"
        v-model="preparationFormModel"
        action="/preparation-fees-for-stop-master"
        tableType="STOP"
      />
    </template>
    <template #footer>
      <PreparationDialogFooter
        @preparation="clickPreparation"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import PreparationForm from '@/components/organisms/dialog/PreparationForm.vue'
import PreparationDialogFooter from '@/components/organisms/dialog/PreparationDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    PreparationForm,
    PreparationDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      preparationFormModel: {
        charge_year: undefined,
        create_year: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickPreparation () {
      this.$loadingMask.on()
      const params = { ...this.preparationFormModel }
      this.$refs.preparationForm.validate()
        .then((valid) => {
          return this.$axios.put('/preparation-fees-for-stop-master', params)
        })
        .then((res) => {
          if (res.status === 202) {
            this.$fcMessage.showMessage({
              id: 'PRE0001I',
              link: {
                fileName: 'warning.txt',
                messages: res.data.message
              }
            }, true)
          } else {
            this.$fcMessage.showMessage(res.data.message)
            this.$set(this.preparationFormModel, 'charge_year', this.preparationFormModel.create_year)
            sessionStorage.setItem('feesForStopMasterSearchCond', JSON.stringify(this.preparationFormModel))
          }
          this.dialogVisible = false
          // this.$emit('refresh', this.preparationFormModel.charge_year)
          this.$emit('refresh', this.preparationFormModel.create_year)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      console.log('FeesForStopMasterPreparationDialog.open')
      this.$nextTick(function () {
        console.log(this.$refs.preparationForm)
        this.$refs.preparationForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
